<template>
  <div class="app-container">
    <!--筛选组-->
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery">
        <el-form-item>
          <el-select v-model="listQuery.logType" placeholder="请选择错误类型" clearable @change="SearchData">
            <el-option label="错误类型" value="ERROR"></el-option>
            <el-option label="点击类型" value="CLICK"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="listQuery.platform" placeholder="请选择操作系统" clearable @change="SearchData">
            <el-option label="苹果" value="ios"></el-option>
            <el-option label="安卓" value="android"></el-option>
            <el-option label="电脑" value="windows"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="listQuery.ip" placeholder="请输入IP" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="listQuery.betweenTime"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="SearchData"
          >搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange">
      <el-table-column align="center" width="100" prop="id" label="编号"></el-table-column>
      <el-table-column align="center" prop="logType" label="日志类型"></el-table-column>
      <el-table-column align="center" prop="code_title" label="日志代码" width="260"></el-table-column>
      <el-table-column align="center" prop="code_message" label="日志说明" width="260"></el-table-column>
      <el-table-column align="center" prop="logTitle" label="日志标题" width="120"></el-table-column>
      <el-table-column align="center" prop="logMessage" label="日志信息" width="400"></el-table-column>
      <el-table-column align="center" prop="logStackError" label="错误栈信息" width="120"></el-table-column>
      <el-table-column align="center" prop="bizType" label="业务类型" width="100"></el-table-column>
      <el-table-column align="center" prop="url" label="当前页面的URL" width="300"></el-table-column>
      <el-table-column align="center" prop="logTime" label="日志生成时间" width="170"></el-table-column>
      <el-table-column align="center" prop="environment" label="运行环境"></el-table-column>
      <el-table-column align="center" prop="deviceId" label="设备ID" width="180"></el-table-column>
      <el-table-column align="center" prop="deviceInfo" label="设备信息" width="320"></el-table-column>
      <el-table-column align="center" prop="nickname" label="用户昵称"></el-table-column>
      <el-table-column align="center" prop="sessionId" label="会话ID" width="300"></el-table-column>
      <el-table-column align="center" prop="traceId" label="RPC跟踪ID" width="110"></el-table-column>
      <el-table-column align="center" prop="platform" label="操作系统平台" width="110"></el-table-column>
      <el-table-column align="center" prop="userAgent" label="用户代理字符串" width="120"></el-table-column>
      <el-table-column align="center" prop="lang" label="语言"></el-table-column>
      <el-table-column align="center" prop="resolution" label="屏幕分辨率" width="100"></el-table-column>
      <el-table-column align="center" prop="groupId" label="业务或设备分组ID" width="160"></el-table-column>
      <el-table-column align="center" prop="costTime" label="耗时"></el-table-column>
      <el-table-column align="center" prop="performanceMetrics" label="性能指标数据" width="120"></el-table-column>
      <el-table-column align="center" prop="extendParams" label="自定义字段" width="100" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" prop="ip" label="IP地址"></el-table-column>
      <el-table-column align="center" prop="geo" label="geo信息"></el-table-column>
      <el-table-column align="center" prop="create_time" label="创建时间" width="160"></el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="loadData"
    />
  </div>
</template>

<script>
import api from '@/api/logs'
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
// import mixin from '@/mixins/mixin'
export default {
  name: 'Logs',
  components: { Pagination },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    return {
      api,
      listQuery: {
        limit: 15
      }
    }
  },
  created() {
    this.loadData() // 页面加载创建时加载数据
  },
  methods: {

  }
}
</script>
<style scoped>
.tableAuto.el-table .cell {
  white-space: nowrap;
}
</style>
